import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';
import { baseQueryWithInterceptor } from '../utils/baseQueryWithInterceptor';
import { IPaginationResponse } from '../../interfaces/common.interface';
import {
  ISpecialty,
  IUniversity,
} from '../../interfaces/university-specialty.interface';

const universitySpecialtyApi = createApi({
  reducerPath: 'universitySpecialtyApi',
  baseQuery: baseQueryWithInterceptor(
    `${config.API_BASE_URL}/university-specialty`
  ),
  tagTypes: ['Universities', 'Specialties'],

  endpoints: (builder) => ({
    getUniversities: builder.query<
      IPaginationResponse<IUniversity>,
      { page?: number; limit?: number; search?: string; sort?: 'asc' | 'desc' }
    >({
      query: ({ page = 1, limit = 10, search = '', sort = 'asc' }) => ({
        url: `/universities`,
        params: { page, limit, search, sort },
      }),
      providesTags: ['Universities'],
    }),

    getSpecialties: builder.query<
      IPaginationResponse<ISpecialty>,
      { page?: number; limit?: number; search?: string; sort?: 'asc' | 'desc' }
    >({
      query: ({ page = 1, limit = 10, search = '', sort = 'asc' }) => ({
        url: `/specialities`,
        params: { page, limit, search, sort },
      }),
      providesTags: ['Specialties'],
    }),

    getSpecialtiesByUniversity: builder.query<
      IPaginationResponse<ISpecialty>,
      {
        universityId: string;
        page?: number;
        limit?: number;
        search?: string;
        sort?: 'asc' | 'desc';
      }
    >({
      query: ({
        universityId,
        page = 1,
        limit = 10,
        search = '',
        sort = 'asc',
      }) => ({
        url: `/university/${universityId}/specialities`,
        params: { page, limit, search, sort },
      }),
      providesTags: ['Specialties'],
    }),
  }),
});

export const {
  useGetUniversitiesQuery,
  useGetSpecialtiesQuery,
  useGetSpecialtiesByUniversityQuery,
} = universitySpecialtyApi;

export default universitySpecialtyApi;
